import React from "react";

import { useRef, useEffect } from "react";
import { useLocation } from "react-router-dom";

import { Link } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import ShoppingBagOutlinedIcon from "@mui/icons-material/ShoppingBagOutlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";

const mainNav = [
  {
    display: "Home",
    path: "/",
  },
  {
    display: "New Arrivals",
    path: "/new-arrivals",
  },
  {
    display: "Women",
    path: "/women",
  },
  {
    display: "Men",
    path: "/men",
  },
  {
    display: "Magazine",
    path: "/magazine",
  },
];

const Header = () => {
  const { pathname } = useLocation();
  const activeNav = mainNav.findIndex((e) => e.path === pathname);

  const headerRef = useRef(null);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (
        document.body.scrollTop > 80 ||
        document.documentElement.scrollTop > 80
      ) {
        headerRef.current.classList.add("shrink");
      } else {
        headerRef.current.classList.remove("shrink");
      }
    });
    return () => {
      window.removeEventListener("scroll", null);
    };
  }, []);

  const menuLeft = useRef(null);

  const menuToggle = () => menuLeft.current.classList.toggle("active");

  return (
    <div className="header" ref={headerRef}>
      <div className="container">
        <div className="header__logo">
          <Link to="/">UPSTYLE.</Link>
        </div>
        <div className="header__menu">
          <div className="header__menu__mobile-toggle" onClick={menuToggle}>
            <MenuIcon />
          </div>
          <div className="header__menu__left" ref={menuLeft}>
            <div className="header__menu__left__close" onClick={menuToggle}>
              <CloseOutlinedIcon />
            </div>
            {mainNav.map((item, index) => (
              <div
                key={index}
                className={`header__menu__item header__menu__left__item ${
                  index === activeNav ? "active" : ""
                }`}
                onClick={menuToggle}
              >
                <Link to={item.path}>
                  <span>{item.display}</span>
                </Link>
              </div>
            ))}
          </div>
          <div className="header__menu__right">
            <div className="header__menu__item header__menu__right__item">
              <SearchOutlinedIcon />
            </div>

            <div className="header__menu__item header__menu__right__item">
              <PersonOutlineOutlinedIcon />
            </div>
            <div className="header__menu__item header__menu__right__item">
              <Link to="/cart">
                <ShoppingBagOutlinedIcon />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Header;
